import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  display: flex;
  width: 97%;
  margin: auto auto;
  margin-top: 10px;
  background: ${Colors.background_secondary};
  padding: 19px 18px 19px 19px;
  max-width: 100vw;
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    display: block;
    width: 97%;
    margin: 0 auto;
    margin-bottom: 36px;
  }
`;


const downloadButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  // @media (min-width: 1280px) {
  //   display: none;
  // }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;
`;

const RightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media (max-width: 1225px) {
    justify-content: flex-start;
  }
`;

const LeftContainer = styled.div`
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 991px) {
    justify-content: center;
    align-items: center;
  }
`;

const ContainerDownload = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid ${Colors.text_secondary};
  height: 40px;
  width: 40px;
  margin-top: 5px;
  mouse-pointer: pointer;
  transition: all 0.3s ease-in-out;
  :hover {
    transform: scale(1.05);
  }
  :active {
    transform: scale(0.99);
  }
`;

const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

const BottomRightItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-self: flex-end;
`;

const SubTitle = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  color: ${Colors.primary};
  margin-bottom: 8px;
`;

const divContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Title2 = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${Colors.text_primary};
  margin-bottom: 13px;

  @media (max-width: 585px) {
    display: none;
    margin-bottom: 0px;
  }
`;


const ContainerSlects = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  margin-top: -3px;
  // @media (min-width: 768px) {
  //   flex-wrap: wrap;
  // }
`;

export default {
  Container,
  Title,
  LeftContainer,
  RightContainer,
  ContainerDownload,
  BottomContainer,
  Title2,
  BottomRightItemsContainer,
  downloadButtonContainer,
  SubTitle,
  divContainer,
  ContainerSlects,
};
